import toggleSelectItemPart from 'owa-mail-reading-pane-store/lib/actions/toggleSelectItemPart';
import ItemPartViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemPartViewState';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { ClientItem } from 'owa-mail-store';

export default function updateSelectedItemPart(item: ClientItem, viewState: ItemViewState) {
    if (viewState.isConversationItemPart) {
        // Update item part selection when trigger surface action button
        toggleSelectItemPart(
            item.ConversationId?.Id,
            viewState as ItemPartViewState,
            false /*toggleExpandedCollapsed*/
        );
    }
}
